import { AccordionBody, AccordionItem, Flex } from "@aircall/tractor";
import styled, { createGlobalStyle } from "@xstyled/styled-components";

import { PlaygroundSectionTitle } from "../PlaygroundSectionTitle";

import { PlaygroundAverage } from "../PlaygroundAverage";
import { PlaygroundEvaluationQuestionSummaryRating } from "../PlaygroundEvaluationQuestionSummaryRating";
import { PlaygroundVirtualAgentTag } from "../PlaygroundVirtualAgentTag/PlaygroundVirtualAgentTag";
import {
  PlaygroundAccordion as PlaygroundAccordionCustom,
  PlaygroundAccordionHeader,
} from "./Playground.styled";

const GlobalStyle = createGlobalStyle`
  html {
    overflow: hidden;
  }
`;

const StyledFlex = styled(Flex)``;

export function Playground() {
  const components = [
    PlaygroundAverage,
    PlaygroundVirtualAgentTag,
    PlaygroundEvaluationQuestionSummaryRating,
  ];

  return (
    <StyledFlex background="white" p="s" gap="xxl" flexDirection="column">
      <GlobalStyle />
      <PlaygroundAccordionCustom defaultSelected="PlaygroundAverage">
        {components.map((Component) => (
          <AccordionItem id={Component.name} key={Component.name}>
            <PlaygroundAccordionHeader>
              <PlaygroundSectionTitle>
                {Component.name.replace("Playground", "")}
              </PlaygroundSectionTitle>
            </PlaygroundAccordionHeader>
            <AccordionBody>
              <Component />
            </AccordionBody>
          </AccordionItem>
        ))}
      </PlaygroundAccordionCustom>
    </StyledFlex>
  );
}
